module.exports = __webpack_public_path__ + "static/media/verify.94e5dc69.png";